const DEAL_FIELDS = new Set([
  "sellerType",
  "propertyType",
  "soldPropertyDate",
  "howPropertyIsSold",
  "valueActualSoldOfProperty",
  "iazamCombinationPercent",
  "percentHoldingShares",
  "totalPropertyCost",
  "hasZaban"
]);

const PART_FIELDS = new Set(["percentBought", "wayOfGettingProperty"]);
const DEDUCTION_FIELDS = new Set(["deduDate", "amount", "deduCurrency"]);

function event(name, value, index) {
  return { target: { name, value }, ...(index === undefined ? {} : { index }) };
}

export function valuesMatch(left, right) {
  if (left === right) return true;
  const isBlank = (value) => value === undefined || value === null || value === "";
  if (isBlank(left) && isBlank(right)) return true;
  if ((typeof left === "number" && typeof right === "string") || (typeof right === "number" && typeof left === "string")) {
    const numericString = typeof left === "string" ? left.trim() : right.trim();
    if (!numericString || !/^-?\d+(\.\d+)?$/.test(numericString)) return false;
    return Number(left) === Number(right);
  }
  return false;
}

export function valueAtPath(form, path) {
  const parts = path.replace(/^deals\./, "").split(".");
  let current = form;
  for (const part of parts) {
    if (part.endsWith("]")) {
      const match = part.match(/^([^[]+)\[(\d+)\]$/);
      if (!match) return undefined;
      current = current?.[match[1]]?.[Number(match[2])];
    } else {
      current = current?.[part];
    }
  }
  return current;
}

function normalizeFact(fact) {
  const path = fact.path.replace(/^deals\./, "");
  const partMatch = path.match(/^calc\.preCalc\.preCalcPartsData\[(\d+)\]\.(.+)$/);
  if (partMatch && PART_FIELDS.has(partMatch[2])) {
    return { kind: "part", name: partMatch[2], index: Number(partMatch[1]), path: fact.path };
  }
  const deductionMatch = path.match(/^calc\.mainCalc\.deductions\[(\d+)\]\.(.+)$/);
  if (deductionMatch && DEDUCTION_FIELDS.has(deductionMatch[2])) {
    return { kind: "deduction", name: deductionMatch[2], index: Number(deductionMatch[1]), path: fact.path };
  }
  if (path === "manage.dealDescription") return { kind: "manage", name: "dealDescription", path: fact.path };
  const preCalcMatch = path.match(/^calc\.preCalc\.(.+)$/);
  if (preCalcMatch && (DEAL_FIELDS.has(preCalcMatch[1]) || preCalcMatch[1] === "stepsBought")) {
    return { kind: "preCalc", name: preCalcMatch[1], path: fact.path };
  }
  return null;
}

export function mapFactsToProjectionEvents(facts, options = {}) {
  const form = options.form || {};
  const precalcSettled = options.precalcSettled === true;
  const snapshotValues = options.snapshotValues || {};
  const mapped = [];
  // A reply carries only the facts its turn applied.
  (facts || []).forEach((fact, sourceOrder) => {
    const descriptor = normalizeFact(fact);
    if (!descriptor) return;
    if (descriptor.kind === "deduction" && !precalcSettled) return;
    const currentValue = valueAtPath(form, fact.path);
    if (Object.prototype.hasOwnProperty.call(snapshotValues, fact.path) && !valuesMatch(currentValue, snapshotValues[fact.path])) return;
    if (valuesMatch(currentValue, fact.value)) return;
    mapped.push({ ...descriptor, fact, sourceOrder, event: event(descriptor.name, fact.value, descriptor.index) });
  });
  return mapped.sort((left, right) => {
    const rank = { manage: 2, preCalc: 3, part: 4, deduction: 5 };
    if (left.name === "stepsBought" && right.name !== "stepsBought") return -1;
    if (right.name === "stepsBought" && left.name !== "stepsBought") return 1;
    return (rank[left.kind] - rank[right.kind]) || left.sourceOrder - right.sourceOrder;
  });
}

export function applyProjectionFacts(facts, options = {}) {
  return { events: mapFactsToProjectionEvents(facts, options) };
}
